import "core-js/stable";
import "regenerator-runtime/runtime";
import LogRocket from 'logrocket';
import * as functions from './functions.js';
import * as layout from './layout.js';
import * as Themeparks from 'themeparks';
import 'bootstrap-icons/font/bootstrap-icons.css';

// LogRocket.init('dhkpdg/orlando-waiting-times');

// Get destinations
var destinationsApi = new Themeparks.DestinationsApi();

destinationsApi.getDestinations().then(function (data) {
    // Add 'all parks' filter
    layout.addAllParksFilter()

    data.destinations.forEach(function (destination) {
        // Check if destination is relevant
        if (functions.includeDestination(destination)) {
            // Add filters
            layout.addDestinationFilter(destination);

            // Add destination parks waiting times
            layout.addDestinationParksWaitingTimes(destination);

            // Add destination parks show times
            layout.addDestinationParksShowTimes(destination);

            // Add destination parks restaurants
            layout.addDestinationParksRestaurants(destination);

            // Add destination parks opening hours modal
            layout.addDestinationParksHoursModal(destination);
        }
    });
}, function (error) {
    console.error(error);
});

// Bottom nav functionaliteit
const bottomNavButtons = document.querySelectorAll('#bottomNav button');
const waitTimesMain = document.getElementById('waitTimes');
const dayPlanMain = document.getElementById('dayPlan');
const showTimesMain = document.getElementById('showTimes');
const restaurantsMain = document.getElementById('restaurants');
const filterBar = document.getElementById('filterBar');

bottomNavButtons.forEach(button => {
    button.addEventListener('click', () => {
        bottomNavButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Get active filter
        var activeFilter = 'all'

        if (filterBar.querySelector('.active')) {
            activeFilter = filterBar.querySelector('.active').dataset.filter
        }

        if (button.dataset.tab === 'waitTimes') {
            waitTimesMain.style.display = 'block';
            showTimesMain.style.display = 'none';
            dayPlanMain.style.display = 'none';
            restaurantsMain.style.display = 'none';
            filterBar.style.display = 'flex';
            functions.filterParks(activeFilter);
        } else if (button.dataset.tab === 'showTimes') {
            waitTimesMain.style.display = 'none';
            showTimesMain.style.display = 'block';
            dayPlanMain.style.display = 'none';
            restaurantsMain.style.display = 'none';
            filterBar.style.display = 'flex';
            functions.filterParks(activeFilter);
        } else if (button.dataset.tab === 'restaurants') {
            waitTimesMain.style.display = 'none';
            showTimesMain.style.display = 'none';
            dayPlanMain.style.display = 'none';
            restaurantsMain.style.display = 'block';
            filterBar.style.display = 'flex';
        } else if (button.dataset.tab === 'dayPlan') {
            waitTimesMain.style.display = 'none';
            showTimesMain.style.display = 'none';
            dayPlanMain.style.display = 'block';
            restaurantsMain.style.display = 'none';
            filterBar.style.display = 'none';
        }

        // Scroll to top
        window.scrollTo(0, 0);
    });
});

// Dagplanning data
const planning = {
    "2025-08-14": [
        { park: "Magic Kingdom", time: "09:00 - 18:00" },
        { park: "Animal Kingdom", time: "18:00 - 22:00" }
    ],
    "2025-08-15": [
        { park: "EPCOT", time: "10:00 - 17:00" },
        { park: "Hollywood Studios", time: "17:30 - 21:00" }
    ],
    "2025-08-16": [
        { park: "Universal Studios Florida", time: "09:00 - 17:00" },
        { park: "Islands of Adventure", time: "18:00 - 22:00" }
    ]
};

function generateDayPlan() {
    const container = dayPlanMain;
    container.innerHTML = '';

    const startDate = new Date(2025, 7, 14);
    const endDate = new Date(2025, 7, 30);

    for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const dateKey = `${y}-${m}-${day}`;

        const dayItem = document.createElement('div');
        dayItem.className = 'day-item';

        const dateTitle = document.createElement('div');
        dateTitle.className = 'day-date';
        dateTitle.textContent = `${day}-${m}-${y}`;
        dayItem.appendChild(dateTitle);

        if (planning[dateKey] && planning[dateKey].length > 0) {
            planning[dateKey].forEach(plan => {
                const parkVisit = document.createElement('div');
                parkVisit.className = 'park-visit';
                parkVisit.innerHTML = `<strong>${plan.park}</strong>: ${plan.time}`;
                dayItem.appendChild(parkVisit);
            });
        } else {
            const noPlan = document.createElement('div');
            noPlan.textContent = 'Geen planning';
            dayItem.appendChild(noPlan);
        }

        container.appendChild(dayItem);
    }
}

generateDayPlan();

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        // Filter parks
        functions.hiddenParksFromStorage().forEach(function (hiddenPark) {
            document.querySelectorAll('.park-section[data-park="' + hiddenPark + '"]').forEach(function (parkSection) {
                parkSection.querySelector('.park-content').classList.add('hidden');
            })
        })

        // Filter destinations
        var destinationsFilter = localStorage.getItem('destinations_filter')

        if (destinationsFilter !== null) {
            functions.filterParks(destinationsFilter)

            document.querySelectorAll('#filterBar button').forEach(btn => btn.classList.remove('active'));

            if (document.querySelector('#filterBar button[data-filter="' + destinationsFilter + '"]')) {
                document.querySelector('#filterBar button[data-filter="' + destinationsFilter + '"]').classList.add('active');
            }
        }
    }, 100)
});